// @ts-nocheck

import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
import * as AppStoreConnectService from '../services/AppStoreConnect';
import { ReduxAsyncAction } from '../support/utils';
import type { AppStoreConnectCredentialsRequestPayload } from '../types/appStoreConnectTypes';
import NotificationActions from './NotificationActions';
const errorProvider = new ErrorProvider();
const INVALID_CREDENTIALS_ERROR = 'Credentials are invalid';
const SaveAppStoreConnectCredentials = new ReduxAsyncAction('SAVE_APP_STORE_CONNECT_CREDENTIALS');
SaveAppStoreConnectCredentials.registerRequest(function (payload: AppStoreConnectCredentialsRequestPayload) {
  return AppStoreConnectService.saveAppStoreConnectCredentials(payload);
});
export const saveAppStoreConnectCredentials =
  (payload: AppStoreConnectCredentialsRequestPayload) =>
  async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(SaveAppStoreConnectCredentials.request(payload));
    } catch (err) {
      if (errorProvider.parse(err).getMessageOrEmpty() === INVALID_CREDENTIALS_ERROR) {
        NotificationActions.showNotification(INVALID_CREDENTIALS_ERROR, 'error');
        return;
      }

      NotificationActions.showNotification('Error saving credentials', 'error');
    }
  };
export const SAVE_APP_STORE_CONNECT_CREDENTIALS = SaveAppStoreConnectCredentials.constants;
const GetAppStoreConnectCredentials = new ReduxAsyncAction('GET_APP_STORE_CONNECT_CREDENTIALS');
GetAppStoreConnectCredentials.registerRequest(function () {
  return AppStoreConnectService.getAppStoreConnectCredentials();
});
export const getAppStoreConnectCredentials = GetAppStoreConnectCredentials.request;
export const GET_APP_STORE_CONNECT_CREDENTIALS = GetAppStoreConnectCredentials.constants;
const DeleteAppStoreConnectCredentials = new ReduxAsyncAction('DELETE_APP_STORE_CONNECT_CREDENTIALS');
DeleteAppStoreConnectCredentials.registerRequest(function () {
  return AppStoreConnectService.deleteAppStoreConnectCredentials();
});
export const deleteAppStoreConnectCredentials = DeleteAppStoreConnectCredentials.request;
export const DELETE_APP_STORE_CONNECT_CREDENTIALS = DeleteAppStoreConnectCredentials.constants;
const GetAppVerificationStatus = new ReduxAsyncAction('GET_APP_VERIFICATION_STATUS');
GetAppVerificationStatus.registerRequest(function () {
  return AppStoreConnectService.getAppVerificationStatus();
});
export const getAppVerificationStatus = GetAppVerificationStatus.request;
export const GET_APP_VERIFICATION_STATUS = GetAppVerificationStatus.constants;
const VerifyApp = new ReduxAsyncAction('VERIFY_APP');
VerifyApp.registerRequest(function () {
  return AppStoreConnectService.verifyApp();
});
export const verifyApp = () => async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
  try {
    await dispatch(VerifyApp.request());
  } catch (err) {
    const message = errorProvider.parse(err).getMessageOrEmpty();
    message && NotificationActions.showNotification(message, 'error');
  }
};
export const VERIFY_APP = VerifyApp.constants;
const RevokeAppVerification = new ReduxAsyncAction('REVOKE_APP_VERIFICATION');
RevokeAppVerification.registerRequest(function () {
  return AppStoreConnectService.revokeAppVerification();
});
export const revokeAppVerification = () => async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
  await dispatch(RevokeAppVerification.request());
  await dispatch(GetAppVerificationStatus.request());
};
export const REVOKE_APP_VERIFICATION = RevokeAppVerification.constants;
